var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (!_vm.isExternal(_vm.item.path))?_c('router-link',{staticClass:"router-link",class:{'router-link-active': _vm.item.path === _vm.$route.path},attrs:{"to":_vm.item.path,"exact":""}},[_vm._v("\n  "+_vm._s(_vm.item.title)+"\n")]):_c('a',{staticClass:"router-link",attrs:{"href":_vm.item.path,"target":"_blank"}},[_vm._v("\n  "+_vm._s(_vm.item.title)+"\n")])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-abfbc724","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/NavLink.vue
// module id = 90
// module chunks = 0